import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

/** Texts of Çalışan Analizi (`employeeAnalysis.*`); the Excel file stays Turkish. */
const useEmployeeAnalysisText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`employeeAnalysis.${key}`, vars), [t]);
  const formatMoney = useCallback((value) => {
    const number = typeof value === 'number' ? value : Number(value);
    return `${(Number.isNaN(number) ? 0 : number).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
  }, [locale]);
  const formatDate = useCallback((assignedAt) => {
    const date = assignedAt?.toDate?.() || (assignedAt instanceof Date ? assignedAt : null);
    return date ? date.toLocaleDateString(locale) : '-';
  }, [locale]);
  return { t, language, locale, label, formatMoney, formatDate };
};

export default useEmployeeAnalysisText;
